import { type ComponentType, lazy, type LazyExoticComponent } from 'react';

export const lazyNamedComponent = <
  K extends string,
  M extends { [Key in K]: ComponentType<any> },
>(
  importFn: () => Promise<M>,
  exportName: K
): LazyExoticComponent<M[K]> =>
  lazy(() =>
    importFn().then((module) => ({
      default: module[exportName],
    }))
  );
